import { c as _c } from "react/compiler-runtime";
import { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import usePDPPrice from 'data-hooks/usePDPPrice';
const QuickViewModalEvents = t0 => {
  const $ = _c(8);
  const {
    productId,
    product,
    slug,
    selectedOptionsVariantSku,
    variantSkuFlashSale
  } = t0;
  const {
    data: priceData
  } = usePDPPrice(productId, slug);
  const [eventTriggered, updateEventTriggered] = useState(false);
  const currentPage = useUserCurrentPageType();
  let t1;
  let t2;
  if ($[0] !== currentPage || $[1] !== eventTriggered || $[2] !== priceData || $[3] !== product || $[4] !== selectedOptionsVariantSku || $[5] !== variantSkuFlashSale) {
    t1 = () => {
      if (eventTriggered === false && !isEmpty(product) && !isEmpty(priceData)) {
        avo.quickviewOpened({
          productId: product.id,
          category: product.type.name,
          isClearance: priceData.isClearance,
          name: product.name,
          price: parseFloat(priceData.price.final_price, 10),
          quantity: 1,
          sku: product.sku,
          variant: selectedOptionsVariantSku,
          fullPrice: parseFloat(priceData.price.original_price, 10),
          productFamily: product.family.name,
          contentIds: [product.sku],
          location: currentPage,
          isFlashSale: variantSkuFlashSale
        });
        updateEventTriggered(true);
      }
    };
    t2 = [priceData, product, selectedOptionsVariantSku, eventTriggered, currentPage, variantSkuFlashSale];
    $[0] = currentPage;
    $[1] = eventTriggered;
    $[2] = priceData;
    $[3] = product;
    $[4] = selectedOptionsVariantSku;
    $[5] = variantSkuFlashSale;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
  return null;
};
QuickViewModalEvents.propTypes = {
  productId: PropTypes.string,
  product: PropTypes.objectOf(PropTypes.object),
  slug: PropTypes.string,
  selectedOptionsVariantSku: PropTypes.string,
  variantSkuFlashSale: PropTypes.objectOf(PropTypes.object)
};
export default memo(QuickViewModalEvents);